var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
/**
 * datastructures-js/linked-list
 * @copyright 2020 Eyas Ranjous <eyas.ranjous@gmail.com>
 * @license MIT
 */
/**
 * @class
 */
var DoublyLinkedListNode = /*#__PURE__*/function () {
  "use strict";

  /**
   * Creates a doubly linked list node.
   * @param {any} value
   * @param {DoublyLinkedListNode} [prev]
   * @param {DoublyLinkedListNode} [next]
   */
  function DoublyLinkedListNode(value, prev, next) {
    _classCallCheck(this, DoublyLinkedListNode);
    this._value = value;
    this.setPrev(prev);
    this.setNext(next);
  }

  /**
   * @public
   * @param {object} value
   */
  _createClass(DoublyLinkedListNode, [{
    key: "setValue",
    value: function setValue(value) {
      this._value = value;
      return this;
    }

    /**
     * @public
     * @returns {object}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      return this._value;
    }

    /**
     * @public
     * @param {DoublyLinkedListNode} [next]
     * @returns {DoublyLinkedListNode}
     */
  }, {
    key: "setNext",
    value: function setNext(next) {
      if (next && !(next instanceof DoublyLinkedListNode)) {
        throw new Error('setNext expects a DoublyLinkedListNode or null');
      }
      this._next = next || null;
      return this;
    }

    /**
     * @public
     * @returns {DoublyLinkedListNode}
     */
  }, {
    key: "getNext",
    value: function getNext() {
      return this._next;
    }

    /**
     * @public
     * @returns {boolean}
     */
  }, {
    key: "hasNext",
    value: function hasNext() {
      return this._next instanceof DoublyLinkedListNode;
    }

    /**
     * @public
     * @param {DoublyLinkedListNode} [prev]
     * @returns {DoublyLinkedList}
     */
  }, {
    key: "setPrev",
    value: function setPrev(prev) {
      if (prev && !(prev instanceof DoublyLinkedListNode)) {
        throw new Error('setPrev expects a DoublyLinkedListNode or null');
      }
      this._prev = prev || null;
      return this;
    }

    /**
     * @public
     * @returns {DoublyLinkedListNode}
     */
  }, {
    key: "getPrev",
    value: function getPrev() {
      return this._prev;
    }

    /**
     * @public
     * @returns {boolean}
     */
  }, {
    key: "hasPrev",
    value: function hasPrev() {
      return this._prev instanceof DoublyLinkedListNode;
    }
  }]);
  return DoublyLinkedListNode;
}();
exports.DoublyLinkedListNode = DoublyLinkedListNode;